import { Col, Row } from "react-bootstrap";
import { ISiteVisitDetails } from "../../../api/ISiteVisit";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface SiteVisitDetailsProps {
  siteVisit: ISiteVisitDetails;
}

const SiteVisitDetails = ({ siteVisit }: SiteVisitDetailsProps) => {
  var summaryText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque aliquet, diam sit amet blandit cursus, ex lectus ultrices sapien, dapibus viverra mauris odio id risus. Aliquam erat volutpat. Nam mattis blandit mi euismod tristique. In eget diam risus. Quisque lacinia accumsan est non sagittis. Fusce lacinia sed justo eu dapibus. Cras ac libero augue. Integer lectus tellus, ultricies eget placerat non, semper sed nisi. In hac habitasse platea dictumst.

Pellentesque pellentesque, mauris ac laoreet laoreet, nisi mauris scelerisque eros, vitae ullamcorper diam diam ut odio. Nulla convallis id elit sed ullamcorper. Proin eget libero tellus. Ut finibus placerat mollis. Duis eros augue, pulvinar luctus semper sed, rhoncus eu nisi. Curabitur rhoncus ornare dolor, pharetra pharetra metus fermentum non. Integer eleifend, diam eget mollis varius, augue ipsum lobortis est, eu mollis purus mauris vel libero. Mauris pellentesque enim sed nunc suscipit, eu mollis purus dignissim. Proin eget erat vestibulum, finibus tellus eu, lobortis purus. Pellentesque scelerisque odio eu laoreet suscipit.
  `;
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField label={"Site Visit Date"} value={siteVisit.visit_date} />
          <EpaField label={"Site Visit Title"} value={siteVisit.subject} />
          <EpaField
            label={"Visit Announced by EPA?"}
            value={siteVisit.announced}
          />
          <EpaField label={"Sample Taken?"} value={siteVisit.sampletaken} />
          <EpaField
            label={"Site Visit Compliant?"}
            value={siteVisit.compliance}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Report Issued Date"}
            value={siteVisit.report_issued_date}
          />
          <EpaField label={"Visit Type"} value={siteVisit.instigated_by} />
          <EpaField
            label={"Odour Assessment Carried Out?"}
            value={siteVisit.odourassessment}
          />
          <EpaField
            label={"Odour Assessment Compliant?"}
            value={siteVisit.adourassessmentcompliant}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Summary"}
            value={siteVisit.summary}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Site Visit Details"} content={bodyElements} />;
};

export default SiteVisitDetails;
